var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tx-dice-row",
      class: { "tx-dice-row--float": _vm.floatResult },
      attrs: { "aria-label": `Dice result: ${_vm.resultDice.join(", ")}` },
    },
    [
      _vm.isClosed
        ? _vm._l(3, function (index) {
            return _c("span", { key: `spin-${index}`, staticClass: "tx-die" }, [
              _c(
                "span",
                {
                  staticClass: "tx-die__spin",
                  style: { "--spin-delay": `${-(index - 1) * 140}ms` },
                },
                _vm._l(6, function (face) {
                  return _c("img", {
                    key: face,
                    staticClass: "tx-die__face",
                    style: {
                      "--face-delay": `${-(
                        (face - 1) * 90 +
                        (index - 1) * 200
                      )}ms`,
                    },
                    attrs: { src: _vm.diceImage(face), alt: "" },
                  })
                }),
                0
              ),
            ])
          })
        : _vm.isResultPlaying
        ? _vm._l(_vm.tableResultDice, function (die, index) {
            return _c(
              "span",
              {
                key: `land-${_vm.animationKey}-${index}`,
                staticClass: "tx-die",
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tx-die__spin tx-die__spin--out",
                    style: {
                      "--spin-delay": `${-index * 140}ms`,
                      "--stop-delay": `${index * _vm.DIE_STOP_STEP_MS}ms`,
                    },
                  },
                  _vm._l(6, function (face) {
                    return _c("img", {
                      key: face,
                      staticClass: "tx-die__face",
                      style: {
                        "--face-delay": `${-((face - 1) * 90 + index * 200)}ms`,
                      },
                      attrs: { src: _vm.diceImage(face), alt: "" },
                    })
                  }),
                  0
                ),
                _c("img", {
                  staticClass: "tx-die__land",
                  style: {
                    "--stop-delay": `${index * _vm.DIE_STOP_STEP_MS}ms`,
                  },
                  attrs: {
                    src: _vm.diceImage(die),
                    alt: `Die ${index + 1}: ${die}`,
                  },
                }),
              ]
            )
          })
        : _vm._l(_vm.resultDice, function (die, index) {
            return _c(
              "span",
              { key: `still-${index}`, staticClass: "tx-die" },
              [
                _c("img", {
                  attrs: {
                    src: _vm.diceImage(die),
                    alt: `Die ${index + 1}: ${die}`,
                  },
                }),
              ]
            )
          }),
      _vm.resultReady
        ? _c(
            "span",
            {
              key: `result-${_vm.animationKey}`,
              staticClass: "tx-dice-row__result",
              class: [
                _vm.resultSide,
                { "tx-dice-row__result--animated": _vm.isResultPlaying },
              ],
            },
            [
              _c("span", { staticClass: "tx-dice-row__equals" }, [_vm._v("=")]),
              _c("strong", { staticClass: "tx-dice-row__total" }, [
                _vm._v(_vm._s(_vm.resultTotal)),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }